module.exports = __webpack_public_path__ + "img/E2 UP5.97813d26.png";